
export enum TriggerPolicyTypeEnum {
  ANALOG_BAND = "ANALOG_BAND",
  ON_CHANGED = "ON_CHANGED",
  CONNECTION = "CONNECTION",
  ON_LEVEL = "ON_LEVEL",
}

export const ALARM_POLICY_TYPE = [
  {value: TriggerPolicyTypeEnum.ON_CHANGED, title: 'On Change'},
  {value: TriggerPolicyTypeEnum.ON_LEVEL, title: 'On Level'},
  {value: TriggerPolicyTypeEnum.ANALOG_BAND, title: 'Analog Band'},
  {value: TriggerPolicyTypeEnum.CONNECTION, title: 'Connection'}
]

export enum TriggerPolicyModelPathMatcherEnum {
  SIMPLE = "simple",
  ADVANCED = "advanced",
}


export enum ModelTypeEnum {
  INTEGER = 'integer',
  STRING = 'string',
  DOUBLE = 'double',
  BOOLEAN = 'boolean',
  ARRAY = 'array',
  OBJECT = 'object',
  STRUCT = 'struct',
  INTEGERARRAY = 'integerarray',
  DOUBLEARRAY = 'doublearray',
  BOOLEANARRAY = 'booleanarray',
  BINARYBLOB = 'binaryblob',
  EXISTING_MODEL = 'ExistingModel'
}

export function modelTypeToInputPropControlType(type: ModelTypeEnum) : string {
  switch(type) {
    case ModelTypeEnum.BOOLEAN:
    case ModelTypeEnum.BOOLEANARRAY:
      return "boolean";
    case ModelTypeEnum.INTEGER:
    case ModelTypeEnum.DOUBLE:
    case ModelTypeEnum.INTEGERARRAY:
    case ModelTypeEnum.DOUBLEARRAY:
      return "numeric";
    case ModelTypeEnum.OBJECT:
    case ModelTypeEnum.STRUCT:
      return "model";
    default:
      return "string";
  }
}


export enum TriggerPolicyChangeMaskEnum {
  VALUE_CHANGED = "VALUE_CHANGED",
  TIMESTAMP_CHANGED = "TIMESTAMP_CHANGED",
}

export enum TriggerPolicyLevelMaskEnum {
  ON_ENTER = "ON_ENTER",
  ON_EXIT = "ON_EXIT",
}

export enum TriggerPolicyConnectionSourceEnum {
  VPN = "VPN",
  IOT = "IOT",
}

export enum TriggerPolicyConnectionStatusEnum {
  ON = "ON",
  OFF = "OFF",
}

export enum TriggerPolicySourceEnum {
  REAL_DEVICE = "realDevice",
  SIMULATION = "simulation",
}

export interface TriggerPolicyAnalogBand {
  modelPathMatcher: string;
  type: TriggerPolicyTypeEnum.ANALOG_BAND;
  inside: boolean;
  minOrEqual: boolean;
  min: number;
  maxOrEqual: boolean;
  max: number;
  time?: number;
  uuid?: string;
}
export interface TriggerPolicyOnChange {
  modelPathMatcher: string;
  type: TriggerPolicyTypeEnum.ON_CHANGED;
  changeMask: TriggerPolicyChangeMaskEnum.VALUE_CHANGED | TriggerPolicyChangeMaskEnum.TIMESTAMP_CHANGED;
  skipFirstNChanges: number;
  deadband: number;
  isPercentage: boolean;
  uuid?: string;
}
export interface TriggerPolicyOnLevel {
  modelPathMatcher: string;
  type: TriggerPolicyTypeEnum.ON_LEVEL;
  level: string;
  levelBool: boolean;
  mode: TriggerPolicyLevelMaskEnum.ON_ENTER | TriggerPolicyLevelMaskEnum.ON_EXIT;
  skipFirstChanges: number;
  minOrEqual: boolean;
  min: number;
  maxOrEqual: boolean;
  max: number;
  uuid?: string;
}

export interface TriggerPolicyConnection {
  type: TriggerPolicyTypeEnum.CONNECTION;
  source: TriggerPolicyConnectionSourceEnum.IOT | TriggerPolicyConnectionSourceEnum.VPN;
  status: TriggerPolicyConnectionStatusEnum.ON | TriggerPolicyConnectionStatusEnum.OFF;
  time?: number;
}

export type ExistingPolicies = TriggerPolicyAnalogBand | TriggerPolicyOnChange | TriggerPolicyOnLevel | TriggerPolicyConnection;

export interface IModelRequestDTO {
  pageSize: number; 
  orderBy: string; 
  page: number; 
  search?: string; 
  version?: string; 
  name?: string
}
